import { get } from "./base";

export async function getPointList(year) {
    let params = null;
    if (year != null) {
        params = { "year": year }
    }
    let respObj = await get("/bus/score/get-person-score", params);
    return respObj.list;
}